<template>
  <div>
    <el-dialog title="修改" :visible.sync="dialogVisible" width="500px">
      <el-form :model="form" :rules="rules" ref="formRef">
        <el-form-item :label="'回收价格'" prop="price">
          <el-input-number type="textarea" :precision="2" placeholder="请输入" :step="0.01" controls-position="right" v-model="form.price" :min="0.0" :max="99999999" />
        </el-form-item>
        <el-form-item :label="'信息费'" prop="infoFee" v-if="type !== 'JD'">
          <el-input-number type="textarea" :precision="2" placeholder="请输入" :step="0.01" controls-position="right" v-model="form.infoFee" :min="0.0" :max="99999999" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelBtnFun">取 消</el-button>
        <el-button type="primary" @click="confirmBtnFun">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: 'JD'
    }
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        id: undefined,
        price: undefined,
        infoFee: undefined
      },
      rules: {
        price: [{ required: true, message: '请输入回收价格', trigger: 'blur' }],
        infoFee: [{ required: true, message: '请输入信息费', trigger: 'blur' }]
      }
    }
  },
  methods: {
    // 打开弹框
    openDialog(row) {
      this.form.id = row.id
      if (this.type === 'JD') {
        this.form.price = row.price ? row.price : 0
      } else {
        this.form.infoFee = row.infoFee ? row.infoFee : 0
        this.form.price = row.recoveryPrice ? row.recoveryPrice : 0
      }
      this.dialogVisible = true
    },
    // 取消弹框
    cancelBtnFun() {
      this.$refs.formRef.clearValidate()
      this.clearParams()
      this.dialogVisible = false
    },
    clearParams() {
      this.form.id = undefined
      this.form.price = undefined
    },
    // 确认
    confirmBtnFun() {
      let url = this.type === 'JD' ? '/autoapp-default-server-recovery/api/settlement/jdPrice/updateById' : '/autoapp-default-server-recovery/api/settlement/orderPrice/updateById'
      this.$refs.formRef.validate(valid => {
        if (valid) {
          let params = {}
          if (this.type === 'JD') {
            params = {
              id: this.form.id,
              price: parseFloat(this.form.price).toFixed(2)
            }
          } else {
            params = {
              id: this.form.id,
              infoFee: parseFloat(this.form.infoFee).toFixed(2),
              recoveryPrice: parseFloat(this.form.price).toFixed(2)
            }
          }

          // 添加全局loading防止重复提交
          const loading = this.$loading({
            lock: true,
            text: '提交中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });

          this.HttpService.post(url, this.global.clearEmptyParam(params)).then(res => {
            loading.close();
            if (res.statusCode === 200) {
              this.$message.success('已修改')
              this.dialogVisible = false
              this.$emit('getList')
              this.clearParams()
            } else {
              this.$message.error('修改失败,请稍后再试')
            }
          }).catch(error => {
            loading.close();
            this.$message.error('请求失败');
          })
        } else {
          this.$message.warning('请填写价格')
        }
      })
    }
  }
}
</script>
<style scoped lang="scss">
.dialog-footer {
  padding: 20px;
  box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/views/settlementManagement/components/PriceUpdateModal.vue